import launchDarklyService from "../../services/launchdarkly";
// Remove the router import to avoid circular dependency
// import router from "../../router";

const state = {
  isNewDesign: false,
  showEmployeeSidebar: true,
  ideaMDP378: false,
  ideaMDP381: false,
  ideaMDP389: false,
  ideaMDP412: false,
  ideaMDP385: false,
};

const mutations = {
  SET_NEW_DESIGN(state, value) {
    state.isNewDesign = value;
  },
  SET_SHOW_SIDEBAR(state, value) {
    state.showEmployeeSidebar = value;
  },
  SET_IDEA_MDP_378(state, value) {
    state.ideaMDP378 = value;
  },
  SET_IDEA_MDP_381(state, value) {
    state.ideaMDP381 = value;
  },
  SET_IDEA_MDP_389(state, value) {
    state.ideaMDP389 = value;
  },
  SET_IDEA_MDP_412(state, value) {
    state.ideaMDP412 = value;
  },
  SET_IDEA_MDP_385(state, value) {
    state.ideaMDP385 = value;
  },
};

const actions = {
  async checkFeatureFlags({ commit }, currentRoute = null) {
    try {
      if (!launchDarklyService.isInitialized) {
        await launchDarklyService.initialize();
      }

      // Use the Vue plugin's reactive flags instead of direct client access
      const flags = await launchDarklyService.getAllFlags();
      const isNewDesign =
        flags["employee.page_horizontal_menu.enabled"] === true;
      const ideaMDP378 = flags["idea-MDP-378"] === true;
      commit("SET_NEW_DESIGN", isNewDesign);
      commit("SET_IDEA_MDP_378", ideaMDP378);
      const ideaMDP389 = flags["idea-MDP-389"] === true;
      commit("SET_NEW_DESIGN", isNewDesign);
      const ideaMDP381 = flags["idea-MDP-381"] === true;
      commit("SET_IDEA_MDP_381", ideaMDP381);
      commit("SET_IDEA_MDP_389", ideaMDP389);
      const ideaMDP412 = flags["idea-MDP-412"] === true;
      commit("SET_IDEA_MDP_412", ideaMDP412);
      const ideaMDP385 = flags["idea-MDP-385"] === true;
      commit("SET_IDEA_MDP_385", ideaMDP385);
      // Update sidebar visibility based on route and flag
      if (currentRoute && currentRoute.meta.secondSidebar === "employee") {
        commit("SET_SHOW_SIDEBAR", !isNewDesign);
      } else {
        commit("SET_SHOW_SIDEBAR", true);
      }
    } catch (error) {
      console.error("Error checking feature flags:", error);
      commit("SET_SHOW_SIDEBAR", true);
    }
  },

  updateSidebarVisibility({ state, commit }, currentRoute = null) {
    if (currentRoute && currentRoute.meta.secondSidebar === "employee") {
      commit("SET_SHOW_SIDEBAR", !state.isNewDesign);
    } else {
      commit("SET_SHOW_SIDEBAR", true);
    }
  },

  // Method for testing - manually set the flag value
  setTestFlag(
    { commit },
    {
      isNewDesign,
      ideaMDP378,
      ideaMDP381,
      ideaMDP389,
      ideaMDP412,
      ideaMDP385,
      currentRoute = null,
    }
  ) {
    commit("SET_NEW_DESIGN", isNewDesign);
    commit("SET_IDEA_MDP_378", ideaMDP378);
    commit("SET_IDEA_MDP_381", ideaMDP381);
    commit("SET_IDEA_MDP_389", ideaMDP389);
    commit("SET_IDEA_MDP_412", ideaMDP412);
    commit("SET_IDEA_MDP_385", ideaMDP385);
    if (currentRoute && currentRoute.meta.secondSidebar === "employee") {
      commit("SET_SHOW_SIDEBAR", !isNewDesign);
    } else {
      commit("SET_SHOW_SIDEBAR", true);
    }
  },
};

const getters = {
  showEmployeeSidebar: (state) => state.showEmployeeSidebar,
  isNewDesign: (state) => state.isNewDesign,
  ideaMDP378: (state) => state.ideaMDP378,
  ideaMDP381: (state) => state.ideaMDP381,
  ideaMDP389: (state) => state.ideaMDP389,
  ideaMDP412: (state) => state.ideaMDP412,
  ideaMDP385: (state) => state.ideaMDP385,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
